import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import {
  customerEmailFromModel,
  validateCustomerEmailCondition,
  type CustomerEmailState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const CUSTOMER_EMAIL = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CustomerEmailState>>,
): ConditionType<CustomerEmailState, ModelCondition.CustomerEmail> => ({
  name: "Customer email",
  description(state) {
    return `Customer emails: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<CustomerEmailState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return customerEmailFromModel(model);
  },
  toModel(state) {
    return { type: ModelCondition.CUSTOMER_EMAIL, emails: state };
  },
  valid(state) {
    return validateCustomerEmailCondition(state).valid;
  },
});

export { type CustomerEmailState } from "@redotech/redo-model/return-flow/condition-validate";
